import { render, staticRenderFns } from "./DepositRequest.vue?vue&type=template&id=81d3e99e&scoped=true"
import script from "./DepositRequest.vue?vue&type=script&lang=js"
export * from "./DepositRequest.vue?vue&type=script&lang=js"
import style0 from "./DepositRequest.vue?vue&type=style&index=0&id=81d3e99e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d3e99e",
  null
  
)

export default component.exports